import { OverviewContainer, OverviewHighlightText } from "../../CommonComponents/CommonViews";
export const ProjectRunbookRunsListHelp = () => (<OverviewContainer>
        <OverviewHighlightText>
            <p>
                The <b>runs</b> section is where you can check on the status and history of the background tasks <b>associated with this runbook</b> that your Octopus Server is managing.
            </p>
        </OverviewHighlightText>
    </OverviewContainer>);
